<div class="m-4">
    <h4 mat-dialog-title2>{{data.title}}</h4>
    <p class="mat-dialog-message">{{data.message}}</p>
    <div *ngIf="data.link != null"><p class="mat-dialog-message">Link: <a href="{{data.link}}" target="_blank>"><u>{{data.link}}</u></a></p></div>
    <div class="row">
        <button class="btn uni-btn-pos btn-lg" (click)="onOk()">Ok</button>
    </div>
</div>